module.exports = __webpack_public_path__ + "static/media/payrollHeader.295e57ac.svg";